module.exports = __webpack_public_path__ + "img/2.2bfd5899.png";